import { SearchPlacementRequest } from "../placement-search/search-placement-request.model";

export class OverviewEncryptedPayload {
    request: SearchPlacementRequest;
    userHash: string;
    /** filters.session-overview client-side filters; present only when the switch was on at hand-off. */
    filters?: OverviewClientFilters;
}

/** Applied client-side to the returned placements. Null means no filter. */
export class OverviewClientFilters {
    deliveryMode: string = null;
    provisionType: string = null;
}
